import { render, staticRenderFns } from "./PrescriptionItemExtendedSelectLR.vue?vue&type=template&id=07a21286&scoped=true"
import script from "./PrescriptionItemExtendedSelectLR.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemExtendedSelectLR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a21286",
  null
  
)

export default component.exports